export class ApiUtils {
  public static getBaseApiUrl(): string | undefined {
    return process.env.REACT_APP_BASE_API_URL;
  }

  public static getBaseCalcUrl(): string | undefined {
    return process.env.REACT_APP_CALC_API_URL;
  }

  public static getBaseSalesforceApiUrl(): string | undefined {
    return process.env.REACT_APP_BASE_SF_API_URL;
  }

  public static getBaseSalesforceSearchApiUrl(): string | undefined {
    return process.env.REACT_APP_BASE_SF_SEARCH_API_URL;
  }

  public static getBaseMetricApiUrl(): string | undefined {
    return process.env.REACT_APP_BASE_METRIC_API_URL;
  }

  public static getBasePdfApiUrl(): string | undefined {
    return process.env.REACT_APP_PDF_API_URL;
  }
}
